import { db } from "@react-native-firebase/database";
import { getLocalStorageItem } from "core/helpers";
import navhelper from "core/navhelper";
import { get, ref } from "firebase/database";
import React, { useEffect, useState } from "react";
import { Dimensions } from "react-native";
import { DEFAULT_USER_IMAGE, MOBILE_VIEW_WIDTH } from "res/constants";
import Loader from "src/components/Loader";
import { fetchUserName } from "src/utils/UserUtils";
import Menu from "./Menu";
import styles from "./styles/AdminHomeScreenStyles";

const CACHE:any={}

export default function AdminHomeScreen() {
  const [showLoader, setShowLoader] = useState(false);
  const [userName, setUserName] = useState();
  const [userList, setUserList] = useState<Array<any>>(CACHE.userList || []);
  const [searchText, setSearchText] = useState("");
  const [isRefreshing,setIsRefreshing]=useState(false);
  const screenWidth = Dimensions.get("window").width;
  const tableHeadstyle = {
    ...styles.tableHead,
    display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell",
  };

  const [userFilteredList, setUserFilteredList] = useState<Array<any>>(CACHE.userFilteredList || []);
  const loggedinUser = getLocalStorageItem("loggedinUser");

  useEffect(() => {
    if (searchText.length > 0) {
      const trimmedText = searchText.trim().toLowerCase();
      const filteredUser = userList.filter(
        (user) =>
          user.firstName.toLowerCase().includes(trimmedText) ||
          user.lastName.toLowerCase().includes(trimmedText)
      );
      setUserFilteredList(filteredUser);
    } else {
      setUserFilteredList(userList);
    }
  }, [searchText, userList]);
  const fetchUserData = async () => {
    if (CACHE.userList) {
      setShowLoader(false)
      setIsRefreshing(true)
    }
    try {
      if (loggedinUser) {
        const dbRef = ref(db, `profile`);
        await get(dbRef)
          .then((snapshot) => {
            if (snapshot.exists()) {
              const userFetchedData = snapshot.val();
              var records: any = [];
              Object.keys(userFetchedData).forEach((userID) => {
                var userObj = userFetchedData[userID];
                if (userObj.userTypeId !== 1) { // not admin
                  userObj.id = userID;
                  records.push(userObj);
                }
              });
              records=records.sort((x,y)=>x.employmentStatus>y.employmentStatus ? 1:-1)
              CACHE.userList=records
              CACHE.userFilteredList=records
              setUserList(records);
              setUserFilteredList(records);
            } else {
              console.log("No data available for the specified date.");
            }
          })
          .catch((error) => {
            console.error("Failed to retrieve data:", error);
          })
      }
    } catch (error: any) {
      console.error("Error reading data:", error.message);
    }
    finally{
       setIsRefreshing(false)
    }
  };

  const fetchAdminProfileData = async () => {
    const name = await fetchUserName()
    setUserName(name);
  };

  useEffect(() => {
    setShowLoader(true);
    Promise.all([fetchAdminProfileData(),
    fetchUserData()]).finally(()=>
    setShowLoader(false)
  )
  }, []);
  return (
    <div style={styles.outerView}>
      <Menu />
      <div
        style={{
          overflowX: "hidden",
          width: screenWidth < MOBILE_VIEW_WIDTH ? "90%" : "100%",
          padding: "0px 20px 0px 20px",
        }}
      >
        <div
          style={{
            width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "97%",
            fontFamily: "Outfit",
          }}
        >
          <div style={{ width: screenWidth >= MOBILE_VIEW_WIDTH ? "100%" : 153 }}>
            <div style={styles.heading}>Welcome {userName}</div>
          </div>
        </div>
        <div style={styles.reviewContainer}>
                <div style={styles.searchContainer}>
            Search Employees
          </div>
          <div>
            <input
              onChange={(e) => setSearchText(e.target.value)}
              style={{...styles.searchView,
                width: screenWidth <= MOBILE_VIEW_WIDTH ? "95%" : 339,
              }}
              type="text"
              placeholder="Enter Employee name to search"
            />
          </div>
        </div>
        <div
          style={{   ...styles.tableStart,marginTop: screenWidth >= MOBILE_VIEW_WIDTH ? 46 : 28, marginBottom: 20 }}
        >
          {isRefreshing && <p>Refreshing...</p>}
          <table style={styles.tableStyle}>
            <thead style={{ fontSize: 14 }}>
              <tr style={styles.tableRow}>
                <th style={styles.tableHead}>Name</th>
                <th style={tableHeadstyle}>Gender</th>
                <th style={tableHeadstyle}>Job Type</th>
                <th style={tableHeadstyle}>Job Status</th>
                <th style={styles.tableHead}>Phone</th>
                <th style={tableHeadstyle}>Address</th>
              </tr>
            </thead>
            <tbody style={styles.tableBody}>
              {userFilteredList.map((userRecord: any, index: any) => (
                <React.Fragment key={index}>
                  <tr
                    style={{
                      backgroundColor:
                        index % 2 === 0 ? "#2F48581A" : "#D8E6DC",
                    }}
                    onClick={() => navhelper.push('UserDetailsScreen', { user: userRecord },{uid:userRecord.id})}
                  >
                    <td style={styles.tableData2}>
                    <div style={styles.userRecord}>
                      <img src={userRecord.image?userRecord.image:DEFAULT_USER_IMAGE} style={styles.defaultImageStyle}/>
                      <div style={styles.nameField}>
                      {userRecord.firstName} {userRecord.lastName}
                      </div>
                      </div>
                    </td>
                    <td
                      style={{
                        display:
                          screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell",
                      }}
                    >
                      <div style={styles.genderField}>{userRecord.gender}</div>
                    </td>
                    <td
                      style={{
                        display:
                          screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell",
                        borderLeft: "1px solid #2F485880",
                      }}
                    >
                      <div style={{ paddingLeft: "13px" }}>{userRecord.employmentType || "---"}</div>
                    </td>
                    <td
                      style={{
                        display:
                          screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell",
                        borderLeft: "1px solid #2F485880",
                      }}
                    >
                      <div style={{ paddingLeft: "13px" }}>{userRecord.employmentStatus || "---"}</div>
                    </td>
                    <td style={styles.tableData1}>{userRecord.phone}</td>
                    <td
                      style={{
                        display:
                          screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell",
                        borderLeft: "1px solid #2F485880",
                      }}
                    >
                      <div style={styles.genderField}>{userRecord.address}</div>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
          {
            showLoader && (
              <Loader />
            )
          }
        </div>
      </div>

    </div>
  );
}
